/** Shop / My Vault / Sell sub-tabs (prototype's tab bar, extended for the marketplace). */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as api from '../api';
import { s } from '../ui';

const tabStyle = (active: boolean): React.CSSProperties =>
  s('background:none;border:none;padding:0 0 14px;font-weight:600;font-size:15px;cursor:pointer;' +
    (active ? 'color:var(--bs-text);border-bottom:2px solid var(--bs-text);margin-bottom:-1px'
      : 'color:var(--bs-text-label);border-bottom:2px solid transparent;margin-bottom:-1px'));

export const ShopTabs: React.FC<{ active: 'shop' | 'vault' | 'sell' }> = ({ active }) => {
  const navigate = useNavigate();
  const [vaultCount, setVaultCount] = useState<number | null>(null);
  const [canSell, setCanSell] = useState(false);

  useEffect(() => {
    api.getVault().then((r) => setVaultCount(r.items.length)).catch(() => setVaultCount(null));
  }, []);

  useEffect(() => {
    let cancelled = false;
    api.getSellAccess()
      .then((r) => { if (!cancelled) setCanSell(!!(r.allowed || r.has_access)); })
      .catch(() => { if (!cancelled) setCanSell(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div style={s('display:flex;gap:28px;border-bottom:1px solid var(--bs-border);margin-bottom:28px')}>
      <button style={tabStyle(active === 'shop')} onClick={() => navigate('/store/beat-shop')}>Shop</button>
      <button style={tabStyle(active === 'vault')} onClick={() => navigate('/store/beat-shop/vault')}>
        My Vault{vaultCount ? ` (${vaultCount})` : ''}
      </button>
      {canSell && (
        <button style={tabStyle(active === 'sell')} onClick={() => navigate('/store/beat-shop/sell')}>Sell</button>
      )}
    </div>
  );
};
